export default __webpack_public_path__ + "static/Melbourne-531fdfc0f937b3c6a78e9d4c16abffc5.webp";